import { useEffect } from "react";
import { handlePageLoad } from "../utils/accessibility";
import { logPageView } from "../utils/analytics";
import { Trans, useTranslation } from "react-i18next";
import { Accordion } from "@trussworks/react-uswds";
import { AccordionItemProps } from "@trussworks/react-uswds/lib/components/Accordion/Accordion";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import styles from "../markdown-styles.module.css"

const StyledAccordionUpdateContent = styled.div`
  display:inline;
  overflow-wrap:normal;
  font-family:'Comfortaa';
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  background: transparent;
`;

type AboutProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function About({ isOpen, setIsOpen }: AboutProps) {
  useEffect(() => {
    handlePageLoad({ title: t("aboutTitle"), noFocusH1: true});
    logPageView();
  }, []);

  const { t } = useTranslation();

  function getAccordionItem(itemKey: string): AccordionItemProps {
    return {
      title: <span className={"faq-question font-body "} >{`${t(`${itemKey}Question`)}`}</span>,
      expanded: false,
      className: "faqAccordion",
      id: itemKey,
      content: (
        <div className={""} key={itemKey} >
          <div className="">
            <p>
              <Trans 
                i18nKey= {itemKey + 'Answer'}
                components={{ 
                  strong: <span style={{fontWeight: "900"}}></span>,
                  ph988: <a href="tel:988"></a>,
                  link988: <a href="https://988colorado.com"></a>,
                  link988s: <a href="https://988colorado.com/spa"></a>,
                  linkForm: <a href="https://cobha.gov1.qualtrics.com/jfe/form/SV_268Pai7zgwntO3c?Q_Language=EN"></a>,
                  linkIMatter: <a href="https://imattercolorado.org/"></a>,
                  linkLift: <a href="https://liftthelabel.org/GetHelp/"></a>,
                  linkQuitemos: <a href="https://quitemoslaetiqueta.org/"></a>,
                  linkRecvy: <a href="http://RecoveryCardsProject.com/"></a>,
                  linkCRAFT: <a href="http://CRAFTColorado.org/"></a>,
                  linkTough: <a href="http://ToughasaMother.org/"></a>,
                  linkFuerte: <a href="http://FuertecomounaMadre.org/"></a>,
                  linkGet: <a href="https://bha.colorado.gov/help/get-help-mental-health-drugs-or-alcohol/"></a>,
                  lkOP: <a href="https://ownpath.co/"></a>,
                  bulletList: <ul></ul>,
                  orderedList: <ol></ol>,
                  pgph: <p></p>,
                  lkYo: <a href="https://YoImportoColorado.org"></a>,
                  lkSafty: <a href="https://drive.google.com/file/d/1NqOBy8J-wUARCxogVIPg5mc8dKcYNUjl/view"></a>,
                  li: <li></li>,
                  contactUs:<button 
                          type="button" 
                          style={{border: "0px ", padding: 0, color: "blue", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}
                          onClick={contactUsClick}>
                        </button>
                }}
              />
            </p>
          </div>
        </div>
      ),
      headingLevel: "h2",
    };
  }

  function contactUsClick() {
    setIsOpen(true);
  }

  return (
    <div className="aboutBackground nice_font dark_blue" >
      <div>
        <div className="aboutMain" >
          <div className="aboutColorado" ><span >{t("aboutOwnPath")}</span></div>
          <div className=" aboutTextBlock">
            <p className="aboutWhatIsParagraph">
              {/* <ReactMarkdown>{t("aboutParagraph1")}</ReactMarkdown> */}
              <Trans i18nKey='aboutParagraph1' 
                components={{ 
                  link1: <a href="https://bha.colorado.gov/" style={{ border: "0px ", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer", color: "black" }}>x</a>
                }} 
              />
            </p>
            <p className="aboutWhatIsParagraph">
              {t("aboutParagraph1a")}
            </p>
            <p className="aboutWhatIsParagraph">
              <Trans i18nKey='aboutParagraph1b' 
                components={{ link1: <a href="https://ownpath.co" style={{ border: "0px ", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer", color: "black" }}>x</a>}} 
              />
            </p>
          </div>
          <div className="aboutColorado" ><span >{t("aboutColoradoLifts")}</span></div>
          <div className=" aboutTextBlock">
            <p className="aboutWhatIsParagraph">
              {t("aboutParagraph2")}
            </p>
            <p className="aboutWhatIsParagraph">
              <Trans 
                i18nKey='aboutParagraph2a' 
                components={{ link1: <button type="button" 
                  style={{border: "0px ", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}
                  onClick={contactUsClick}>Contact us</button>}}
              />
            </p>
          </div>
          <div className="aboutColorado" ><span >{t("commonQuestions")}</span></div>
          <div className=" aboutTextBlock">
            <Accordion 
              items={[
                "canITalkToSomeoneAboutHowToGetCare",
                "whoCanUseColoradoLifts",
                "doINeedToEnrollToReceiveServices",
                "shouldICallColoradoLiftsIfImInACrisis",
                "whereCanIFindMoreBehavioralHealthResources",
                "whereCanIAskQuestionsOrProvideFeedback",
              ].map(getAccordionItem)}
              bordered={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;